import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NoPermissionError() {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "403",
    illustration: "keys",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "view.noPermission.title"
    }),
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DOCUMENT_NO_PERMISSION"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "view.noPermission.callToAction"
    })]
  });
}